import { z } from 'zod';
import { baseComponentSchema } from '../component-base.schemas';

const hexColorRegex = /^#[0-9A-Fa-f]{6}$/;

export const logocloudCustomColorsSchema = z
  .object({
    background: z.string().regex(hexColorRegex, 'Invalid hex color').optional(),
    title: z.string().regex(hexColorRegex, 'Invalid hex color').optional(),
    subtitle: z.string().regex(hexColorRegex, 'Invalid hex color').optional(),
  })
  .optional();

export const logocloudLogoSchema = z.object({
  name: z.string().max(100, 'Logo name too long').optional(),
  imageUrl: z.string().optional(),
  cloudfrontUrl: z.string().url('Invalid CloudFront URL').optional(),
  mediaId: z.string().uuid('Invalid media ID').optional(),
  linkUrl: z.string().optional(),
});

export const logocloudDataSchema = z.object({
  title: z.string().max(200, 'Title too long').optional(),
  subtitle: z.string().max(500, 'Subtitle too long').optional(),
  logos: z.array(logocloudLogoSchema).default([]),
  layout: z.enum(['row', 'grid']).default('row').optional(),
  columns: z.number().int().min(2).max(6).default(4).optional(),
  grayscale: z.boolean().default(true).optional(),
  maxLogoHeight: z.number().int().min(16).max(200).default(48).optional(),
  customColors: logocloudCustomColorsSchema,
});

export const logocloudComponentSchema = baseComponentSchema.extend({
  type: z.literal('logocloud'),
  data: logocloudDataSchema,
});

export type LogocloudCustomColors = z.infer<typeof logocloudCustomColorsSchema>;
export type LogocloudLogo = z.infer<typeof logocloudLogoSchema>;
export type LogocloudData = z.infer<typeof logocloudDataSchema>;
export type LogocloudComponent = z.infer<typeof logocloudComponentSchema>;
